import { render, staticRenderFns } from "./PreviousButton.vue?vue&type=template&id=09a133f1"
import script from "./PreviousButton.vue?vue&type=script&setup=true&lang=js"
export * from "./PreviousButton.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports